import request from "@/service";

/* 查询顶级部门ID */
export function findMostTopDept() {
  return request({
    url: `/user/sys/dept/findMostTopDept`,
    method: "get"
  });
}

/* 查询部门列表 */
export function deptList(params) {
  return request({
    url: `/user/sys/dept/page?deptName=${
      params.deptName ? params.deptName : ""
    }&unitAttr=${params.unitAttr ? params.unitAttr : ""}&attrCategory=${
      params.attrCategory ? params.attrCategory : ""
    }`,
    method: "get"
  });
}
/* 查询学院列表 */
export function schoolList(params) {
  return request({
    url: `/user/sys/dept/page?parentId=${
      params.parentId ? params.parentId : ""
    }&deptName=${params.deptName ? params.deptName : ""}&unitAttr=${
      params.unitAttr ? params.unitAttr : ""
    }&attrCategory=${params.attrCategory ? params.attrCategory : ""}`,
    method: "get"
  });
}
/* 新增部门列表 */
export function deptAdd(data) {
  return request({
    url: `/user/sys/dept/save`,
    method: "post",
    data
  });
}
/* 修改部门列表 */
export function deptEdit(data) {
  return request({
    url: `/user/sys/dept/update`,
    method: "put",
    data
  });
}
/*部门列表详情 */
export function deptDetail(id) {
  return request({
    url: `/user/sysBizDept/${id}`,
    method: "get"
  });
}
/*部门列表删除*/
export function deptDelete(data) {
  return request({
    url: `/user/sys/dept/delete`,
    method: "delete",
    data
  });
}
/*部门树*/
export function deptTreeNew(data) {
  return request({
    url: `/user/sys/dept/treeNew`,
    method: "get",
    params: data
  });
}
/*部门树*/
export function specialTreeNew(data) {
  return request({
    url: `/user/sys/dept/specialTreeNew`,
    method: "get",
    params: data
  });
}
/*部门树*/
export function deptTree(data) {
  return request({
    url: `/user/sys/dept/tree`,
    method: "get",
    params: data
  });
}
/*用于班级可报名部门选择*/
export function deptTreeForClass(params) {
  let url = "/user/sys/dept/treeForClass";
  // if (params && params.parentId && params.deptName) {
  //   url = `/user/sys/dept/treeForClass?parentId=${params.parentId}&deptName=${params.deptName}`
  // } else {
  //   if(params && params.parentId) {
  //     url = `/user/sys/dept/treeForClass?parentId=${params.parentId}`
  //   }
  //   if(params && params.deptName) {
  //     url = `/user/sys/dept/treeForClass?deptName=${params.deptName}`;
  //   }
  // }
  return request({
    url: url,
    method: "get",
    params
  });
}
/**
 * 办班审核部门数
 * @returns 
 */
export function deptTreeForClassReport() {
  return request({
    url: `/user/sys/dept/treeForReport`,
    method: "get"
  });
}

/*部门树*/
export function deptTreeAll() {
  return request({
    url: `/user/sys/dept/treeAll`,
    method: "get"
  });
}
/*部门树 懒加载*/
export function deptTreeAllNew(data) {
  return request({
    url: `/user/sys/dept/treeAllNew`,
    method: "get",
    params: data
  });
}
/*上下移 下移传1，上移传0,置顶传2*/
export function upAndDown(data) {
  return request({
    url: `/user/sys/dept/upAndDown`,
    method: "post",
    data
  });
}
/*学院列表*/
export function topDeptList() {
  return request({
    url: `/user/sys/dept/topDeptList`,
    method: "get"
  });
}
/*共享学院列表*/
export function shareDeptList() {
  return request({
    url: `/user/sys/dept/shareDeptList`,
    method: "get"
  });
}

/* 拖拽排序 */
export function updateDeptOrderByDrag(data) {
  return request({
    url: "/user/sys/dept/updateDeptOrderByDrag",
    method: "put",
    data
  });
}

/* 拖拽排序 */
export function updateDeptOrderByDragNew(data) {
  return request({
    url: "/user/sys/dept/updateDeptOrderByDragNew",
    method: "put",
    data
  });
}


/* 部门树lazy */
export function lazyTree(data) {
  return request({
    url: "/user/sys/dept/lazyTree",
    method: "get",
    params: data
  });
}

/* 办班申报-部门树lazy */
export function treeForReportNew(data) {
  return request({
    url: "/user/sys/dept/treeForReportNew",
    method: "get",
    params: data
  });
}

/*z部门树【用于班级联络员部门选择】 */
export function liaisonTree() {
  return request({
    url: "/user/sys/dept/treeForClassLiaisonUser",
    method: "get",
  });
}

/*部门树【用于办班计划提交人员选择】*/
// export function treeDeptForClassReport(reportId) {
//   return request({
//     url: `/user/sys/dept/treeDeptForClassReport/${reportId}`,
//     method: "get"
//   });
// }
export function treeDeptForClassReport(params) {
  let url = `/user/sys/dept/treeDeptForClassReport?reportId=${params.reportId}`;
  if (params.parentId) {
    url = url + `&parentId=${params.parentId}`;
  }
  if (params.deptName) {
    url = url + `&deptName=${params.deptName}`;
  }
  return request({
    url: url,
    method: "get",
  });
}

/* 查询部门树顶节点 */
export function getTopDepts(data) {
  return request({
    url: `/user/sys/dept/topDepts`,
    method: "post",
    data
  });
}

/*学院列表(资源统计)-wangchao*/
export function statisticDeptList() {
  return request({
    url: `/user/sys/dept/statisticDeptList`,
    method: "get"
  });
}
/* 学院列表包含顶级节点（简称）-clc */
export function collegeSimpleFullList() {
  return request({
    url: `/user/sys/dept/collegeSimpleFullList`,
    method: "get"
  });
}

/* 查询顶级部门树-clc */
export function topTreeByRole() {
  return request({
    url: `/user/sys/dept/topTreeByRole`,
    method: "get"
  });
}

/*查询部门树-全部部门 不和登录用户角色挂钩-clc 懒加载*/
export function treeHideProvince(data) {
  return request({
    url: `/user/sys/dept/treeHideProvince`,
    method: "get",
    params: data
  });
}





